<template>
  <dl class="grid gap-y-4" style="grid-template-columns: fit-content(10rem) 1fr">
    <template v-for="({ label, text, url }, i) in data" :key="i">
      <template v-if="label && text">
        <dt class="pr-2 fw-bold">
          <span>
            <product-barcode :text="label" />
          </span>
        </dt>
        <dd>
          <base-link v-if="url" :to="url">
            {{ text }}
          </base-link>
          <span v-else>
            <product-barcode :text />
          </span>
        </dd>
      </template>
    </template>
  </dl>
</template>

<script lang="ts" setup>
import type { ProductDetailContent } from '#types/product'

defineProps<{
  data: ProductDetailContent[]
}>()
</script>
